import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';

//Alert
import SweetAlert from 'react-bootstrap-sweetalert';
import swal from 'sweetalert';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as HotelsActions from './redux/HotelsActions';

import auth from '../../libCustom/auth';

class HotelsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedRows: [],
      openConfirmArchived: false,
    };
  }

  async componentDidMount() {
    console.log({ USUARIO: this.state });
    this.props.find({
      $sort: {
        name: 1,
      },
      isDeleted: { $ne: true },
      $select: ['name', 'address', 'description', 'images', 'imagesWeb'],
    });
  }

  transformRows = (rows) => {
    if (rows.length > 0) {
      rows.map((item) => {
        if (item && item.images && item.images.length) {
          item.imagesText = 'Imágenes Usuario (' + item.images.length + ')';
        } else if (item && item.imagesWeb && item.imagesWeb.length) {
          item.imagesText = 'Imágenes Web (' + item.imagesWeb.length + ')';
        } else {
          item.imagesText = 'Sin Imágenes';
        }
      });
    }
    return rows;
  };

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  toggleRow = (id) => {
    const { selectedRows } = this.state;
    const index = selectedRows.indexOf(id);

    if (index > -1) {
      this.setState({
        selectedRows: selectedRows.filter((rowId) => rowId !== id),
      });
    } else {
      this.setState({
        selectedRows: [...selectedRows, id],
      });
    }
  };

  toggleSelectAll = () => {
    const { selectedRows } = this.state;
    const { Hotels } = this.props;
    const currentData = Hotels.searchData || Hotels.data;

    if (selectedRows.length === currentData.length) {
      this.setState({ selectedRows: [] });
    } else {
      this.setState({
        selectedRows: currentData.map((row) => row._id),
      });
    }
  };

  handleBulkAction = () => {
    const { selectedRows } = this.state;
    console.log('Acción masiva para:', selectedRows);
    this.setState({
      openConfirmArchived: true,
    });
  };

  onDelete(confirm) {
    let _this = this;
    console.log('selectedRows', this.state.selectedRows);
    if (confirm) {
      this.props
        .updateMultiple(this.state.selectedRows, { isDeleted: true })
        .then(function () {
          _this.props.find({
            $sort: {
              name: 1,
            },
            isDeleted: { $ne: true },
            $select: ['name', 'address', 'description', 'images', 'imagesWeb'],
          });
        });

      _this.setState({
        selectedRows: [],
        openConfirmArchived: false,
      });
    } else {
      this.setState({ openConfirmArchived: true });
    }
  }

  checkUser() {
    if (auth.can('support') || auth.can('adminHotel')) {
      return true;
    }
    return false;
  }

  render() {
    let _this = this;
    let { history, Hotels } = this.props;
    const { selectedRows, openConfirmArchived } = this.state;
    return (
      <div className="main-content">
        {openConfirmArchived && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirmArchived: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás deshacer está opción!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Hoteles'}{' '}
                    <div className="pull-right header-table">
                      {this.checkUser() && selectedRows.length > 0 && (
                        <Button
                          bsStyle="info"
                          wd
                          onClick={this.handleBulkAction}
                          style={{ marginRight: '10px' }}
                        >
                          <i className="fa fa-check-circle" /> Archivar Hoteles
                          ({selectedRows.length})
                        </Button>
                      )}
                      {auth.can('support') || auth.can('adminHotel') ? (
                        <Button
                          bsStyle="primary"
                          wd
                          onClick={() =>
                            history.push('/admin/config/hotels/create')
                          }
                        >
                          Agregar Hotel
                        </Button>
                      ) : null}
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Hotels.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={
                      Hotels.searchData
                        ? this.transformRows(Hotels.searchData)
                        : this.transformRows(Hotels.data)
                    }
                    page={Hotels.table.page}
                    filtered={Hotels.table.filtered}
                    pageSize={Hotels.table.pageSize}
                    onSortedChange={(change) =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={(change) =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={(change) =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={(change) =>
                      _this.props.changeTable('pageSize', change)
                    }
                    previousText={'Anterior'}
                    nextText={'Siguiente'}
                    loadingText={'Cargando...'}
                    noDataText={'No se encontraron registros'}
                    pageText={'Página'}
                    ofText={'de'}
                    rowsText={'filas'}
                    columns={[
                      {
                        Header: 'Seleccionar',
                        /*Header:
                        () => (
                          <input
                            type="checkbox"
                            checked={
                              selectedRows.length > 0 &&
                              selectedRows.length ===
                                (Hotels.searchData || Hotels.data).length
                            }
                            onChange={this.toggleSelectAll}
                          />
                        ),*/
                        accessor: 'selection',
                        sortable: false,
                        filterable: false,
                        width: 100,
                        Cell: (props) => (
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(props.original._id)}
                            onChange={() => this.toggleRow(props.original._id)}
                          />
                        ),
                      },
                      {
                        Header: 'Nombre',
                        accessor: 'name',
                        minWidth: 120,
                      },
                      {
                        Header: 'Dirección',
                        accessor: 'address',
                      },
                      {
                        Header: 'Descripción',
                        accessor: 'description',
                        minWidth: 200,
                      },
                      {
                        Header: 'Imágenes',
                        accessor: 'imagesText',
                        minWidth: 90,
                      },
                      {
                        Header: 'Acciones',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: (props) =>
                          auth.can('support') || auth.can('adminHotel') ? (
                            <div className="actions-right">
                              <Button
                                onClick={() =>
                                  window.open(
                                    `/#/admin/config/hotels/${props.original._id}`,
                                    '_blank'
                                  )
                                }
                                bsStyle="warning"
                                simple
                              >
                                Editar
                              </Button>{' '}
                            </div>
                          ) : null,
                      },
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Hotels: state.Hotels,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(HotelsActions, dispatch);
};

const HotelsConnect = connect(mapStateToProps, mapDispatchToProps)(HotelsIndex);

export default HotelsConnect;



// WEBPACK FOOTER //
// ./src/views/Hotels/HotelsIndex.jsx